import React from 'react';
import { withTranslation } from '../../ChildrenContext.js';
import PropTypes from 'prop-types';
import ConversionList from './ConversionList/ConversionList.container';

const ConversionPage = ({ t }) => {
    const staticNames = t?.conversionPage || {};

    return (
        <React.Fragment>
            <div className="page-heading">
                <div className="page-heading__inner">
                    <h2>{staticNames.title}</h2>
                </div>
            </div>

            <section className="wrapper-content statistics conversion">
                <div className="ibox">
                    <ConversionList />
                </div>
            </section>
        </React.Fragment>
    );
};

ConversionPage.propTypes = {
    t: PropTypes.object
};

ConversionPage.defaultProps = {
    t: {}
};

export default withTranslation(ConversionPage);
